import React from "react";

function ChartCard({ title, children, className }) {
  return (
    <div className={`px-4  pt-4 pb-10 bg-grayish rounded-2xl shadow-md h-auto ${className || ""}`}>
      <h6 className="text-lg font-bold text-main1 mb-3">{title}</h6>
      {children}
    </div>
  );
}

export default ChartCard;
